import { salesRepActionKeys as keys } from './salesRepActionKeys';
import { ISalesRep, ISalesRepCallGoal } from './salesRepInterfaces';

const deleteSalesRep = (sid: string) => ({ type: keys.DELETE_SALES_REP, payload: { sid } });
export type DeleteSalesRep = ReturnType<typeof deleteSalesRep>;
const fetchSalesRepCallGoals = (payload: { sid: string; fiscalYear: string }) => ({
  payload,
  type: keys.FETCH_SALES_REP_CALL_GOALS
});
export type FetchSalesRepCallGoals = ReturnType<typeof fetchSalesRepCallGoals>;

const fetchSalesReps = () => ({ type: keys.FETCH_SALES_REPS });
export type FetchSalesReps = ReturnType<typeof fetchSalesReps>;
const removeSalesRep = (sid: string) => ({ type: keys.REMOVE_SALES_REP, payload: { sid } });
export type RemoveSalesRep = ReturnType<typeof removeSalesRep>;

const saveSalesRep = (payload: ISalesRep) => ({ type: keys.SAVE_SALES_REP, payload });
export type SaveSalesRep = ReturnType<typeof saveSalesRep>;
const saveSalesRepCallGoals = (payload: ISalesRepCallGoal) => ({ payload, type: keys.SAVE_SALES_REP_CALL_GOALS });
export type SaveSalesRepCallGoals = ReturnType<typeof saveSalesRepCallGoals>;
const setSalesRepCallGoals = (payload: ISalesRepCallGoal[]) => ({ payload, type: keys.SET_SALES_REP_CALL_GOALS });
export type SetSalesRepCallGoals = ReturnType<typeof setSalesRepCallGoals>;
const setSalesReps = (payload: ISalesRep[]) => ({ payload, type: keys.SET_SALES_REPS });
export type SetSalesReps = ReturnType<typeof setSalesReps>;

export const salesRepActionCreators = {
  deleteSalesRep,
  fetchSalesRepCallGoals,
  fetchSalesReps,
  removeSalesRep,
  saveSalesRep,
  saveSalesRepCallGoals,
  setSalesRepCallGoals,
  setSalesReps
};

export type SalesRepActionTypes =
  | DeleteSalesRep
  | FetchSalesRepCallGoals
  | FetchSalesReps
  | RemoveSalesRep
  | SaveSalesRep
  | SaveSalesRepCallGoals
  | SetSalesRepCallGoals
  | SetSalesReps;
